// import '../plugins/scroll-to'

const CATEGORY_SELECT_CLASS = 'category-select'
const CATEGORY_SELECT_COLLAPSE_CLASS = `${CATEGORY_SELECT_CLASS}__content`
const CATEGORY_SELECT_ACTIVE_CLASS = `${CATEGORY_SELECT_CLASS}--active`
const CATEGORY_SELECT_ITEM_CLASS = `${CATEGORY_SELECT_CLASS}__item`
const CATEGORY_SELECT_ITEM_LINK_CLASS = `${CATEGORY_SELECT_CLASS}__link`
const CATEGORY_SELECT_CURRENT_ITEM_CLASS = `${CATEGORY_SELECT_CLASS}__item--current`
const CATEGORY_SELECT_HEADING_CLASS = `${CATEGORY_SELECT_CLASS}__heading-text`

let select

export default {
  $collapse: undefined,
  current: 'all',

  init(scope) {
    select = this
    select.scroll()
    select.$collapse = $(`.${CATEGORY_SELECT_COLLAPSE_CLASS}`, scope)
    const $parent = select.$collapse.parents(`.${CATEGORY_SELECT_CLASS}`)
    const $items = select.$collapse.find(`.${CATEGORY_SELECT_ITEM_CLASS}`)

    select.$collapse.on('show.bs.collapse', () => {
      $parent.addClass(CATEGORY_SELECT_ACTIVE_CLASS)
    })

    select.$collapse.on('hidden.bs.collapse', () => {
      $parent.removeClass(CATEGORY_SELECT_ACTIVE_CLASS)
      $items.removeClass(CATEGORY_SELECT_CURRENT_ITEM_CLASS)
      $items.find(`[data-filter="${select.current}"]`).parent().addClass(CATEGORY_SELECT_CURRENT_ITEM_CLASS)
    })

    $items.each(function(index, target) {
      $(target).find(`.${CATEGORY_SELECT_ITEM_LINK_CLASS}`).on('click', (e) => {
        select.filter($(e.target).data('filter'), $(e.target).text())
      })
    })
  },

  scroll() {
    // if ($('.shop__category-container').length) {
    //   $('.shop__category-container').height($('.shop__category').outerHeight(true))
    //   $('.shop__category').addClass('shop__category--absolute')
    //
    //   let previousScroll = $(window).scrollTop()
    //   if (previousScroll < 0) previousScroll = 0
    //   let direction = "down"
    //   let boxCleared = false
    //   let bottomCleared = true
    //
    //   $(window).on('scroll orientationchange', function() {
    //     let newScroll = $(window).scrollTop()
    //     if (newScroll < 0) newScroll = 0
    //     let difference = newScroll - previousScroll
    //     previousScroll = newScroll
    //     bottomCleared = $('.shop__products + .bg-cream').length ? newScroll < $('.shop__products + .bg-cream').offset().top - ($(window).height() / 2) : true;
    //
    //     if (direction == "down" && difference < 0 && boxCleared && bottomCleared) {
    //       direction = "up"
    //       boxCleared = false
    //       $('.shop__category').css('top', '').removeClass('shop__category--absolute').hide()
    //       $('.shop__category').addClass('shop__category--fixed').fadeIn(150)
    //     } else if (direction == "down" && difference < 0 && !boxCleared && ($('.shop__category').offset().top - newScroll > $('.shop__category-container').offset().top)) {
    //       direction = "up"
    //       $('.shop__category').css('top', '').removeClass('shop__category--absolute')
    //       $('.shop__category').addClass('shop__category--fixed')
    //     } else if (direction == "down" && difference > 0 && !boxCleared) {
    //       let clearPosition = $('.shop__category').offset().top + $('.shop__category').outerHeight() - newScroll
    //       if (clearPosition < 0) {
    //         boxCleared = true
    //         select.$collapse.collapse('hide')
    //       }
    //     } else if (direction == "up" && difference > 0) {
    //       direction = "down"
    //       $('.shop__category').removeClass('shop__category--fixed')
    //       $('.shop__category').addClass('shop__category--absolute').css({
    //         top: newScroll + 'px',
    //       })
    //     }
    //   })
    // }
  },

  filter(slug, name) {
    if (slug) {
      select.current = slug

      if ($('body').hasClass('page-template-faq')) {
        $('.faq-sections').css('height', $('.faq-sections').css('height') + 'px');
        $('.faq-sections__item').fadeOut('fast', function() {
          $('#faq-' + select.current).show();
          let targetHeight = $('#faq-' + select.current).outerHeight(true);
          if (targetHeight < 200) {
            targetHeight = 200;
          }
          $('#faq-' + select.current).hide();
          $('.faq-sections').animate({
            'height': targetHeight + 'px',
          }, 450, 'swing', function() {
            $('#faq-' + select.current).fadeIn('fast');
            setTimeout(function() {
              $('.faq-sections').css({
                'height': '',
                'minHeight': '200px',
              });
            }, 100);
          })
        })
      }
    }

    const $heading = $(`.${CATEGORY_SELECT_HEADING_CLASS}`)
    $heading.text(name)
    select.$collapse.collapse('hide')
  },
}
